import axios from "axios";
import * as Constants from "../constant";

const siginupUser = async (signupData) => {
	try {
		const response = await axios.post(
			`${Constants?.LOCAL_URL}/users`,
			signupData
		);
		return response.data;
	} catch (error) {
		return error;
	}
};
export default siginupUser;
